'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../atoms/icon/font-icon/font-icon.js');
require('react-transition-group');
require('../../../atoms/alert/inline-alert/inline-alert.js');
require('../../../atoms/alert/standard-alert/standard-alert.js');
require('boring-avatars');
require('../../../atoms/tooltip/hover-tooltip/hover-tooltip.js');
require('react-laag');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('styled-components');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
require('../../../../utilities/color.js');
require('date-fns');
require('../../../../utilities/locale.js');
require('@brandfolder/utilities');
require('../../../atoms/button/close-button/close-button.js');
require('../../../atoms/button/color-button/color-button.js');
require('../../../../hooks/use-prevent-keyboard-scrolling.js');
require('../../../atoms/button/icon-button/icon-button.js');
require('../../../atoms/button/standard-button/standard-button.js');
var circleLoader = require('../../../atoms/loader/circle-loader/circle-loader.js');
require('../../../atoms/loader/shimmer-loader/shimmer-loader.js');
require('../../../atoms/divider/standard-divider/standard-divider.js');
require('../../../atoms/fieldset/standard-fieldset/standard-fieldset.js');
require('../../../atoms/heading/standard-heading/standard-heading.js');
require('../../../atoms/label/standard-label/standard-label.js');
require('../../../atoms/link/button-link/button-link.js');
require('../../../atoms/link/standard-link/standard-link.js');
require('../../../atoms/popout/standard-popout/standard-popout.js');
require('../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js');
require('../../../atoms/table/standard-table/caption.js');
require('../../../atoms/table/standard-table/tbody.js');
require('../../../atoms/table/standard-table/tr-empty.js');
require('../../../atoms/table/standard-table/td.js');
require('../../../atoms/table/standard-table/tr.js');
require('../../../atoms/table/standard-table/table.js');
require('../../../atoms/table/standard-table/tfoot.js');
require('../../../atoms/table/standard-table/th.js');
require('../../../atoms/table/standard-table/thead.js');
require('../../../atoms/table/dnd-table/dnd-handle-td.js');
require('../../../atoms/table/dnd-table/dnd-table-drag-context.js');
require('../../../atoms/text/help-text/help-text.js');
require('../../../atoms/text/standard-text/standard-text.js');
var tabButton = require('./components/tab-button.js');
var tabList = require('./components/tab-list.js');
var tabPanel = require('./components/tab-panel.js');
var tabSlider = require('./components/tab-slider.js');
var tabUnderline = require('./components/tab-underline.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Base tabs
 * @param props BaseTabsProps
 */ const BaseTabs = (props)=>{
    const { activatePanelOnPrevNext =true , caption , changeToIndex , className , id , initialActiveIndex , loaderLabel , loading , onChange , showSlider , showUnderline , tabButtonProps , tabListProps , tabPanelProps , tabSliderProps , tabUnderlineProps , tabs , ...otherProps } = props;
    const [activeIndex, setActiveIndex] = React.useState(initialActiveIndex || 0);
    const [focusIndex, setFocusIndex] = React.useState(null);
    const length = tabs.length;
    const zeroBasedLength = length - 1;
    const handleTabChange = (index)=>{
        setActiveIndex(index);
        if (onChange) {
            onChange(index);
        }
    };
    /**
   * Handling left arrow, right arrow, spacebar, home, and end keys are required for accessibility compliance
   * https://www.w3.org/TR/wai-aria-practices-1.2/#keyboard-interaction-20
   */ const handleTabButtonKeyUp = (e, index)=>{
        // only handle tab button previous/next if we have more than one tab button
        if (length > 1) {
            // left arrow key goes to the previous tab button or wraps around to the last tab button
            if (e.key === 'ArrowLeft') {
                if (activatePanelOnPrevNext) {
                    const prev = activeIndex - 1;
                    const prevIndex = prev < 0 ? zeroBasedLength : prev;
                    setActiveIndex(prevIndex);
                    if (onChange) {
                        onChange(prevIndex);
                    }
                } else {
                    const prev = (focusIndex || 0) - 1;
                    const prevIndex = prev < 0 ? zeroBasedLength : prev;
                    setFocusIndex(prevIndex);
                }
            }
            // right arrow key goes to the next tab button or wraps back around to the first tab button
            if (e.key === 'ArrowRight') {
                if (activatePanelOnPrevNext) {
                    const next = activeIndex + 1;
                    const nextIndex = next > zeroBasedLength ? 0 : next;
                    setActiveIndex(nextIndex);
                    if (onChange) {
                        onChange(nextIndex);
                    }
                } else {
                    const next = (focusIndex || 0) + 1;
                    const nextIndex = next > zeroBasedLength ? 0 : next;
                    setFocusIndex(nextIndex);
                }
            }
            // space/spacebar (enter is handled by onClick below)
            if (e.key === ' ' || e.key === 'Spacebar') {
                handleTabChange(index);
            }
            // home goes to the first tab button
            if (e.key === 'Home') {
                if (activatePanelOnPrevNext) {
                    setActiveIndex(0);
                    if (onChange) {
                        onChange(0);
                    }
                } else {
                    setFocusIndex(0);
                }
            }
            // end goes to the last tab button
            if (e.key === 'End') {
                if (activatePanelOnPrevNext) {
                    setActiveIndex(zeroBasedLength);
                    if (onChange) {
                        onChange(zeroBasedLength);
                    }
                } else {
                    setFocusIndex(zeroBasedLength);
                }
            }
        }
    };
    React.useEffect(()=>{
        // let the parent component change the tab (if it's a valid tab)
        if (typeof changeToIndex === 'number' && changeToIndex >= 0 && changeToIndex < length && changeToIndex !== activeIndex) {
            setActiveIndex(changeToIndex);
            if (onChange) {
                onChange(changeToIndex);
            }
        }
    }, [
        changeToIndex
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        // for storybook
        if (initialActiveIndex !== undefined) {
            handleTabChange(initialActiveIndex);
        }
    }, [
        initialActiveIndex
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        // if a tab is removed and that was the active tab
        // reset the activeIndex back to the first tab
        if (activeIndex > tabs.length - 1) {
            setActiveIndex(0);
        }
    }, [
        tabs.length
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ React__default.default.createElement("div", _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-tabs': true,
            [`${className}`]: !!className
        }),
        id: id
    }), /*#__PURE__*/ React__default.default.createElement(tabList.TabList, _extends({}, tabListProps, {
        caption: caption
    }), tabs.map((tab, index)=>/*#__PURE__*/ React__default.default.createElement(tabButton.TabButton, _extends({}, tabButtonProps, {
            key: `${id}-button-${index}`,
            active: activeIndex === index,
            activeIndex: activeIndex,
            disabled: tab.disabled,
            focusIndex: focusIndex,
            id: `${id}-button-${index}`,
            index: index,
            onClick: ()=>handleTabChange(index),
            onKeyUp: (e)=>handleTabButtonKeyUp(e, index),
            tabPanelId: `${id}-panel-${index}`
        }), tab.tabButton)), showSlider && /*#__PURE__*/ React__default.default.createElement(tabSlider.TabSlider, _extends({}, tabSliderProps, {
        activeIndex: activeIndex,
        numberOfTabs: length
    })), showUnderline && /*#__PURE__*/ React__default.default.createElement(tabUnderline.TabUnderline, _extends({}, tabUnderlineProps))), tabs.map((tab, index)=>/*#__PURE__*/ React__default.default.createElement(tabPanel.TabPanel, _extends({}, tabPanelProps, {
            key: `${id}-panel-${index}`,
            active: activeIndex === index,
            id: `${id}-panel-${index}`,
            tabButtonId: `${id}-button-${index}`
        }), !loading && !tab.loading && tab.tabPanel, loaderLabel && (loading || tab.loading) && /*#__PURE__*/ React__default.default.createElement(circleLoader.CircleLoader, {
            label: loaderLabel
        }))));
};

exports.BaseTabs = BaseTabs;
//# sourceMappingURL=base-tabs.js.map
